import { useEffect, useState } from 'react';

import { api, ApiError, type ApiMenuCategory } from '../lib/api';
import { FIXTURE_MENU } from '../lib/fixtures';

interface MenuState {
  categories: ApiMenuCategory[];
  isLoading: boolean;
  error: string | null;
}

const USE_FIXTURES: boolean = String(import.meta.env.VITE_USE_FIXTURES ?? 'false') === 'true';

export function useMenu(branchId?: string): MenuState {
  const [state, setState] = useState<MenuState>(() =>
    USE_FIXTURES
      ? { categories: FIXTURE_MENU, isLoading: false, error: null }
      : { categories: [], isLoading: true, error: null },
  );

  useEffect(() => {
    if (USE_FIXTURES) return;

    let cancelled = false;
    setState({ categories: [], isLoading: true, error: null });

    api
      .getMenu(branchId)
      .then((categories) => {
        if (cancelled) return;
        setState({ categories, isLoading: false, error: null });
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        const message =
          err instanceof ApiError
            ? String(err.status) + ' — ' + err.message
            : err instanceof Error
              ? err.message
              : 'Unknown error';
        setState({ categories: [], isLoading: false, error: message });
      });

    return () => {
      cancelled = true;
    };
  }, [branchId]);

  return state;
}
